import { Link } from "@tanstack/react-router";

import { cn } from "@/lib/utils";

const tabBase =
  "flex-1 px-6 py-4 text-center font-sans text-sm font-semibold uppercase tracking-[0.08em] transition sm:text-base";

/** Two-tab switcher between the one-time and monthly donation forms. */
export function DonateTabs({ active }: { active: "one-time" | "monthly" }) {
  return (
    <div className="mt-10 flex max-w-lg overflow-hidden rounded-lg">
      <Link
        to="/donation-form"
        className={cn(
          tabBase,
          active === "one-time" ? "bg-navy text-white" : "bg-[#6b6b6b] text-white",
        )}
      >
        One-time Payment
      </Link>
      <Link
        to="/donation-form/monthly-recurring"
        className={cn(
          tabBase,
          active === "monthly" ? "bg-navy text-white" : "bg-[#6b6b6b] text-white",
        )}
      >
        Monthly Recurring
      </Link>
    </div>
  );
}
